<template>
  <div class="home-container">

    <el-card style="margin-top: 10px;">
      <div style="display: flex;justify-content: flex-end;">
        <div style="display: flex">
          <div style="flex: 1">
            <el-input v-model="name" placeholder="请输入内容"></el-input>
          </div>
          <div style="flex: 1">
            <el-button style="margin-left: 10px;" @click="load">搜索</el-button>
            <el-button style="margin-left: 10px;" type="warning" @click="reset">重置</el-button>
          </div>
        </div>

      </div>
    </el-card>

    <div ref="parent" class="item-center">
      <el-row :gutter="24">
        <el-col :span="calculateSpan">

          <div v-for="item in items">
            <div class="item" >
              <div v-if="!isNavCollapsed" class="item-img">
                <img :src="item.img" style="height: 100%;width: 100%">
              </div>
              <div class="item-container"><!--@click="$router.push('/front/articleDetail?id='+item.id)"-->
                <div class="item-title" style="cursor: pointer" @click="ArClick(item.url,item.id)">
                  <span style="font-size: 20px;font-weight: bolder;">{{item.name}}</span>
                </div>
                <div class="item-content">
                  <p>
                    {{item.content}}
                  </p>
                </div>
                <div class="item-info">
                  <span>发布时间:{{item.time}}</span>
                </div>
              </div>
            </div>
            <el-divider />
          </div>

          <div style="padding: 10px 0;text-align: center;margin-top: 10px;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[2, 5, 10, 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </el-col>

        <el-col v-if="!isNavCollapsed" :span="7">

          <el-card>
            <el-carousel height="300px" :interval="10000">
              <el-carousel-item v-for="item in imgs" :key="item">
                <img :src="item" style="width: 100%;height: 100%">
              </el-carousel-item>
            </el-carousel>
          </el-card>

        </el-col>
        <el-col  v-else :span="0">
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>

export default {
  name: "",
  data() {
    return {
      isNavCollapsed: false, // 控制导航栏是否折叠
      isNavExpanded: false, // 控制下拉菜单是否展开
      parentWidth: window.innerWidth, // 初始宽度，将在mounted中更新
      items:[],
      name:'',
      pageNum:1,
      pageSize:10,
      total:0,
      imgs: [
        "http://47.108.174.230:9090/file/33d5d474eb5c4802a107495589af1e7e.jpg",
        "http://47.108.174.230:9090/file/c9cfaa7011aa41dd8301c3e81461349e.jpg",
        "http://47.108.174.230:9090/file/ff9babe6f3d7439ba9e3bbc7e190cb0e.jpg",
      ],
    };
  },
  created(){
    this.load()
  },
  mounted() {
    // 页面加载时从localStorage中读取状态
    window.addEventListener('resize', this.updateParentWidth);
    this.updateParentWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateParentWidth);
  },
  computed: {
    calculateSpan(){
      return this.isNavCollapsed ? 24:17
    },
  },
  methods:{
    updateParentWidth() {
      this.parentWidth = this.$refs.parent.offsetWidth;
      this.checkNavCollapse();
    },
    checkNavCollapse() {
      this.isNavCollapsed = this.parentWidth < 500;
    },
    ArClick(url,id) {
      // 判断url是否为空
      if (!url || url.trim() === '') {
        this.$router.push('/front/articleDetail?id='+id);
      } else {

        this.goToUrl(url);
      }
    },
    goToUrl(url) {
      window.open(url, '_blank'); // 在新标签页中打开链接
      // 或者使用 window.location.href = url; 在当前标签页中打开链接
    },
    load(){
      this.request.get("/article/page",{
        params:{
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          name:this.name,
        }
      }).then(res=>{
        if(res.code==='200'){
          this.items=res.data?.records || []
          this.total=res.data?.total || 0
        }
      })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.load()
    },
    reset(){
      this.name=''
      this.load()
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

.home-container {
  width: 70%;
  margin: 0 auto;
  .item-center{
    .el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      margin: 10px 0;
    }
    margin-top: 20px;
    .item{
      width: 100%;
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item-img{
        height: 100%;
        width: 100%;
        flex: 1;
      }
      .item-container{
        flex: 5;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        .item-title{
          height: 15%;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; /* 这里是超出几行省略 */
          overflow: hidden;
        }
        .item-content{
          height: 55%;
          line-height: 1.6;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3; /* 这里是超出几行省略 */
          overflow: hidden;
        }
        .item-info{
          margin-top: 5px;
          height: 20%;
        }
      }
    }
  }
}
</style>
